import { createMuiTheme } from '@material-ui/core/styles';

/** ANA Universal MaaSの配色などを適用したテーマ。 */
export const universalMaaS = createMuiTheme({
  palette: {
    text: {
      primary: '#002596',
      secondary: '#373737',
    },
    primary: {
      main: '#002596',
      dark: '#002596',
    },
    secondary: {
      main: '#0090e8',
      dark: '#0090e8',
    },
    error: {
      main: '#BF0000',
    }
  },
  typography: {
    fontFamily: [
      'Noto Sans JP',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  overrides: {
    MuiAppBar: {
      root: {
        borderBottom: '1px solid #CBD2E3',
      }
    },
    MuiButton: {
      root: {
        borderRadius: '2px',
      }
    },
    MuiInput: {
      input: {
        '&::placeholder': {
          color: '#526391',
          opacity: 0.8,
          fontSize: '11px',
        }
      },
      underline: {
        '&:before': {
          borderBottom: '1px solid #CBD2E3',
        }
      },
    },
    MuiInputLabel: {
      root: {
        color: '#526391',
      }
    },
    MuiOutlinedInput: {
      input: {
        '&::placeholder': {
          color: '#526391',
          opacity: 0.8,
          fontSize: "0.75rem",
        }
      },
      notchedOutline: {
        border: '1px solid #CBD2E3',
      },
    },
    MuiPaper: {
      elevation4: {
        boxShadow: undefined,
      }
    },
    MuiSelect: {
      icon: {
        color: '#0B308E',
      }
    },
  }
});
